<div (mouseenter)="this.dotComService.DisplaySubMenu('')">
    <div class="headerImageHeight4" style="background-size: cover; background-position:center;"
        [ngStyle]="{backgroundImage: 'url(' + this.pageImagePaths + 'header-image.jpg)'}">
        <div class="row">
            <div style="width:10%"></div>
            <div *ngIf="myHarrellsService.bootstrapViewPortSize != ''" class="text-center whiteText" style="width:80%">
                <h1 *ngIf="(myHarrellsService.bootstrapViewPortSize == 'xs' || this.myHarrellsService.bootstrapViewPortSize == 'sm')"
                    class="DINNextLTPro-Black whiteText headerImageTextLarge" style="text-transform: uppercase;">CAREERS
                </h1>
                <h1 *ngIf="myHarrellsService.bootstrapViewPortSize && myHarrellsService.bootstrapViewPortSize != '' && !(this.myHarrellsService.bootstrapViewPortSize == 'xs' || this.myHarrellsService.bootstrapViewPortSize == 'sm')"
                    class="DINNextLTPro-Black whiteText headerImageTextLarge" style="text-transform: uppercase;">COME
                    WORK WITH US AT HARRELL’S</h1>
            </div>
            <div style="width:10%"></div>
        </div>
    </div>

    <div class="mt-5 mb-3" style="max-width:1500px; margin:auto; margin-left:10%; margin-right:10%">
        <h2 class="Caecilia76BoldItalic greenText" style="font-size:28px; font-weight: 700; ">Current Openings</h2>
        <div *ngFor="let job of this.thirdPartyJobPostings" style="border-bottom:solid 1px grey;">
            <div class="row" (click)="ToggleExpand(job.title)">
                <h6 class="DIN2014Regular"
                    style="padding-bottom:10px;margin-top:25px;display:inline-block;font-size:21px; line-height:25px; letter-spacing: 0.42px">
                    {{job.title}}
                    <img *ngIf="this.jobToDisplay == job.title" src="{{this.pageImagePaths + 'up-arrow.png'}}"
                        alt="arrow up" style="cursor:pointer;float:right;margin-top:10px">
                    <img *ngIf="this.jobToDisplay != job.title" src="{{this.pageImagePaths + 'down-arrow.png'}}"
                        alt="arrow down" style="cursor:pointer;float:right;margin-top:10px">
                </h6>
            </div>
            <div *ngIf="this.jobToDisplay == job.title">

                <div class="row mb-2 pt-3">
                    <div class="col-md-6">
                        <h6 class="DIN2014Regular" style="font-size:19px; font-weight:400;">
                            {{job.description}}</h6>
                    </div>
                    <div class="col-md-6 mb-3" style="text-align: right;margin-top:10px">
                        <a class="DIN2014Bold greenBackground whiteText"
                            style="font-size:20px; font-weight:700; padding:12px; text-decoration: none !important"
                            href="{{job.applyURL}}" target="_blank">APPLY NOW</a>
                    </div>
                </div>
            </div>
        </div>
    </div>

    <div class="row"
        style="background-size: cover; background-position:center; padding-top:50px; padding-bottom:40px; margin-top: 50px;"
        [ngStyle]="{backgroundImage: 'url(' + this.baseImagePaths + 'harrells-pattern.png)'}">
        <div class="col-lg-12 blackText ">
            <h4 class="Caecilia76BoldItalic whiteText"
                style="display:inline-block;text-align: left; margin-left:10%; font-size:34px; font-weight:700">
                Already have an application in progress?
            </h4>
            <h3 style="float:right; margin-right:10%"><a class="DIN2014Bold whiteBackground greenText"
                    style="font-size:20PX ;padding:8pt; text-decoration: none !important" target="_blank"
                    href='https://theapplicantmanager.com/application?co=h5&retrieve'>FIND IT HERE</a>
            </h3>
        </div>
    </div>

    <div style="margin-left:10%; margin-right:10%; margin-top:50px; margin-bottom:50px">
        <div class="row mt-3 ">
            <h2 class="DIN2014Regular blackText"
                style="font-size:16px; line-height:19px; font-weight: 400; letter-spacing: .38px; ">
                Harrell’s LLC is an <a class="blueText" href="https://www.dol.gov/agencies/ofccp/posters"
                    target="_blank">Equal Opportunity/Affirmative Action Employer</a> – Protected Veterans/Disabled.
            </h2>
        </div>
        <!-- <div class="row mt-3 ">
            <h2 class="DIN2014Regular blackText"
                style="font-size:16px; line-height:19px; font-weight: 400; letter-spacing: .38px; ">Qualified
                individuals with a disability have the right to request a reasonable accommodation. If you are unable or
                limited in your ability to use or access our careers website as a result of your disability, request a
                reasonable accommodation by: (1) sending an e-mail to: <a class="blueText"
                    href="mailto:careers@harrells.com"> careers&#64;harrells.com</a> or by calling (800) 282-8007 ext.
                2289, (2) informing us regarding the nature of your request, and (3) providing your contact information.
                <b>Please do not direct any other general employment related questions to this email and/or phone
                    number.</b> Only inquiries concerning a request for a reasonable accommodation will be responded to
                from this e-mail address and/or phone number.
            </h2>
        </div> -->
        <!-- THE <b> embedded above was making iphone not work -->
        <div class="row mt-3 ">
            <h2 class="DIN2014Regular blackText"
                style="font-size:16px; line-height:19px; font-weight: 400; letter-spacing: .38px; ">Qualified
                individuals with a disability have the right to request a reasonable accommodation. If you are unable or
                limited in your ability to use or access our careers website as a result of your disability, request a
                reasonable accommodation by: (1) sending an e-mail to: <a class='blueText'
                    href='mailto:careers@harrells.com'> careers&#64;harrells.com</a> or by calling (800) 282-8007 ext.
                2289, (2) informing us regarding the nature of your request, and (3) providing your contact information.
                Please do not direct any other general employment related questions to this email and/or phone
                number. Only inquiries concerning a request for a reasonable accommodation will be responded to
                from this e-mail address and/or phone number.
            </h2>
        </div>
        <div class="row mt-3 ">
            <h2 class="DIN2014Regular blackText"
                style="font-size:16px; line-height:19px; font-weight: 400; letter-spacing: .38px; ">All qualified
                applicants will receive consideration for employment without regard to race, color, religion, sex,
                sexual orientation, gender identity, national origin, GINA, and age.</h2>
        </div>
        <div class="row mt-3 ">
            <h2 class="DIN2014Regular blackText"
                style="font-size:16px; line-height:19px; font-weight: 400; letter-spacing: .38px; ">If you have any
                complications, please contact the HR Team for assistance at <a class="blueText"
                    href="mailto:hr@harrells.com"> hr&#64;harrells.com</a> or by phone 1-800-282-8007 ext. 2289.</h2>
        </div>
        <div class="row mt-3">
            <h2 class="DIN2014Regular blackText"
                style="font-size:16px; line-height:19px; font-weight: 400; letter-spacing: .38px; ">Harrell’s is a
                Drug-Free Workplace.</h2>
        </div>
        <div class="row mt-3">
            <img style="border: 0px; background-repeat: no-repeat; display: block; padding:0px; width:100px; height:100px; position:relative; top:-9vh; left:80%  "
                title="I E Verify Seal" src="{{this.pageImagePaths + '1595-i-e-verify-seal-v2.jpg'}}"
                alt="I E Verify Seal" width="100" height="100">
        </div>
    </div>

    <div class="row">
        <div class="col-9 blueBackground whiteText" style="padding-top:5%;padding-left:11%">
            <h4 class="DIN2014Bold" style="text-align: LEFT; font-size:36px; line-height: 46px;">
                Have questions? We are happy to help! Don't hesitate to reach out to our HR team with inquiries
                about open positions or assistance with your application.</h4>
        </div>
        <div class="col-3 blueBackground whiteText" style="padding-top:3%">
        </div>
    </div>
    <div class="row blueBackground" style="padding-bottom:5%;padding-left:10.5%">
        <div class="col-9" style="padding-top:3%">
            <h3><a class="DIN2014Bold whiteBackground greenText"
                    style="font-size:20PX ;padding:8pt; text-decoration: none !important"
                    href='mailto:hr@harrells.com?subject=Application Question'>CONNECT WITH US</a>
            </h3>
        </div>
    </div>


</div>